import React, { PureComponent } from 'react';
import { ProgressBar } from '@cassette/components';
import {
  playerContextFilter,
  isPlaylistValid
} from '@cassette/core';

function convertToTime(number) {
  const mins = Math.floor(number / 60);
  const secs = (number % 60).toFixed();
  return `${mins < 10 ? '0' : ''}${mins}:${secs < 10 ? '0' : ''}${secs}`;
}

export class MediaProgress extends PureComponent {
  constructor(props) {
    super(props);

    // bind methods fired on React events
    this.handleSeekPreview = this.handleSeekPreview.bind(this);
  }

  handleSeekPreview(progress) {
    this.props.onSeekPreview(progress * this.props.duration);
  }

  render() {
    const {
      playlist,
      currentTime,
      seekPreviewTime,
      seekInProgress,
      duration,
      tempduration,
      onSeekComplete
    } = this.props;
    const time = seekInProgress ? seekPreviewTime : currentTime;
    const displayedProgress = duration ? time / duration : 0;
    return (
      <div className="cassette__media_progress_container d-flex align-items-center">
        <div className="playerTime first">{convertToTime(time)}</div>
        <ProgressBar
          className="cassette__media_progress_bar"
          progressClassName="audio_progress"
          progress={displayedProgress}
          progressDirection="right"
          adjusting={seekInProgress}
          readonly={!isPlaylistValid(playlist)}
          onAdjustProgress={this.handleSeekPreview}
          onAdjustComplete={onSeekComplete}
        />
        <div className="playerTime last">{convertToTime(duration > 0 ? duration : tempduration)}</div>
      </div>
    );
  }
}

export default playerContextFilter(MediaProgress, [
  'playlist',
  'activeTrackIndex',
  'currentTime',
  'seekPreviewTime',
  'seekInProgress',
  'duration',
  'onSeekPreview',
  'onSeekComplete'
]);



// WEBPACK FOOTER //
// ./src/js/components/Mui/AudioProgress.js